import { useQueries } from '@tanstack/react-query';

import { apiClient } from '../axios.js';
import type { MetricName, TelemetryMetricResponse } from '../types/telemetry.js';

export interface UseTelemetryParams {
  deviceId: string;
  metrics: MetricName[];
  from?: string;
  to?: string;
  refetchInterval?: number | false;
}

export const useTelemetry = ({
  deviceId,
  metrics,
  from,
  to,
  refetchInterval = false,
}: UseTelemetryParams) => {
  return useQueries({
    queries: metrics.map((metricName) => ({
      queryKey: ['telemetry', deviceId, metricName, from, to],
      queryFn: async () => {
        const params: Record<string, string> = {};
        if (from) params.from = new Date(from).toISOString();
        if (to) params.to = new Date(to).toISOString();
        const { data } = await apiClient.get<TelemetryMetricResponse>(
          `/devices/${deviceId}/telemetry/${metricName}`,
          { params },
        );
        return data;
      },
      refetchInterval,
      staleTime: 0,
    })),
  });
};
